// extracted by mini-css-extract-plugin
export default {"root":"AboutSection_root__7cvMd","title":"AboutSection_title__JYnWb","facts":"AboutSection_facts__6nhFA","fact":"AboutSection_fact__Eu9v4","text":"AboutSection_text__NF4oS"};